window.Common = function () {
    var el = this;

    el.getScale = function () {
        let scale = 1;

        switch (el.mode) {
            case 'reversals':
                scale = el.reversal.workAreaScale;
                break;
            case 'hardcover':
                scale = el.hardcover.workAreaScale;
                break;
        }

        return scale;
    }

    el.isSelectMultiple = function () {
        if (el.selectType === 'multiple') {
            return true;
        }

        return false;
    }

    el.convertYE = function (value) {
        return value / (el.currentFormat.width / el.WORKAREA_WIDTH);
    }

    el.convertMM = function (value) {
        return value * (el.currentFormat.width / el.WORKAREA_WIDTH);
    }

    el.cutArea = { x: 0, y: 0, width: 0, height: 0 };
    el.safeArea = { x: 0, y: 0, width: 0, height: 0 };

    el.initCutArea = function () {
        if (el.mode === 'reversals') {
            el.common.cutArea = {
                x1: el.reversal.templateData.safeArea.x2,
                y1: el.reversal.templateData.safeArea.y2,
                x2: el.reversal.templateData.safeArea.width2,
                y2: el.reversal.templateData.safeArea.height2
            };
        } else {
            el.common.cutArea = {
                x1: el.hardcover.templateData.safeArea.x2,
                y1: el.hardcover.templateData.safeArea.y2,
                x2: el.hardcover.templateData.safeArea.width2,
                y2: el.hardcover.templateData.safeArea.height2
            };
        }
    }

    el.initSafeArea = function () {
        if (el.mode === 'reversals') {
            el.safeArea = {
                x1: el.reversal.templateData.cutArea.x2,
                y1: el.reversal.templateData.cutArea.y2,
                x2: el.reversal.templateData.cutArea.width2,
                y2: el.reversal.templateData.cutArea.height2
            };
        } else {
            el.safeArea = {
                x1: el.hardcover.templateData.cutArea.x2,
                y1: el.hardcover.templateData.cutArea.y2,
                x2: el.hardcover.templateData.cutArea.width2,
                y2: el.hardcover.templateData.cutArea.height2
            };
        }
    }

    el.getCenterCoords = function () {
        el.initSafeArea();
        let horizontalСenter, verticalСenter, horizontalCenterPage1, horizontalCenterPage2, halfPageWidth, horizontalCenterPage3 = 0;

        switch (el.mode) {
            case 'reversals':
                horizontalСenter = Math.round(el.workData.width / 2);
                verticalСenter = Math.round(el.workData.height / 2);

                if (el.reversal.templateData.hasOwnProperty('leftSafeArea') && el.reversal.templateData.hasOwnProperty('rightSafeArea')) {
                    halfPageWidth1 = (el.reversal.templateData.leftSafeArea.x1 - el.safeArea.x1) / 2;
                    halfPageWidth3 = (el.safeArea.x2 - el.reversal.templateData.rightSafeArea.x2) / 2;

                    horizontalCenterPage1 = Math.round(el.safeArea.x1 + halfPageWidth1);
                    horizontalCenterPage2 =  Math.round(el.safeArea.x2 - halfPageWidth3);
                    horizontalCenterPage3 =  Math.round(el.reversal.templateData.leftSafeArea.x2 + halfPageWidth3);
                    break;
                }

                halfPageWidth = (el.reversal.templateData.centerSafeArea.x1 - el.safeArea.x1) / 2;

                horizontalCenterPage1 = Math.round(el.safeArea.x1 + halfPageWidth);
                horizontalCenterPage2 = Math.round(el.reversal.templateData.centerSafeArea.x2 + halfPageWidth);
                break;
            case 'hardcover':
                horizontalСenter = Math.round(el.workData.hardcover[el.currentReversal].width / 2);
                verticalСenter = Math.round(el.workData.hardcover[el.currentReversal].height / 2);

                halfPageWidth = (el.hardcover.templateData.parted.left.x1 - el.safeArea.x1) / 2;

                horizontalCenterPage1 = Math.round(el.safeArea.x1 + halfPageWidth);
                horizontalCenterPage2 = Math.round(el.hardcover.templateData.parted.right.x1 + halfPageWidth);
                if (el.hardcover.templateData.hasOwnProperty('parted_right')) {
                    horizontalCenterPage3 = Math.round(el.hardcover.templateData.parted_right.right.x1 + halfPageWidth);
                }
                break;
        }

        return {horizontalСenter, verticalСenter, horizontalCenterPage1, horizontalCenterPage2, horizontalCenterPage3}
    }

    el.generateReversalName = function (currentKey, count, bookType) {
        let name = '';
        if (parseInt(bookType) === el.PAGE_BINDING_ID) {
            switch (currentKey) {
                case 1:
                    name = currentKey + ' ' + Yii.t('page');
                    break;
                case count:
                    name = Yii.t('Last page');
                    break;
                default:
                    name = (currentKey * 2 - 2) + ' - ' + (currentKey * 2 - 1) + ' ' + Yii.t('pages');
            }
        } else {
            name = currentKey + ' ' + Yii.t('reversal');
        }

        return name;
    }
};
